export function createCssClass(classNames?: string | any[] | (() => string) | (() => string)[]): string {

  let result: string[] = [];

  if (!(Array.isArray(classNames))) classNames = [classNames];

  for (let cssClass of classNames) {
    if (!cssClass) continue;
    else if (typeof cssClass === 'function') {
      if (!cssClass()) continue;
      result.push(cssClass().toString());
    }
    else result.push(cssClass.toString());
  }

  return result.join(' ');
}

export const wait = (timeout: number | "random" = 1000): Promise<void> => {
  if (timeout === "random") timeout = Math.random() * 800;

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, timeout as number);
  });
};

